import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonos } from '../data/salesData';
export function BonosSection() {
  return <section className="border-b border-[var(--line)] bg-[var(--bg-alt)] py-16 sm:py-20" data-id="element-15" data-mp="1855ysqgw6opd">
      <div className="mx-auto max-w-6xl px-4" data-id="element-16" data-mp="13cmj9nyn9jhx">
        <SectionHeading eyebrow="Siempre incluidos" data-id="element-17" data-mp="yeulwef8d56c">Los 6 Bonos</SectionHeading>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-18" data-mp="yd08rma7ahct">
          {bonos.map(bono => <article key={bono.number} className="relative flex flex-col rounded-2xl border border-[var(--line)] bg-[var(--surface)] p-6 transition-colors duration-200 ease-out hover:border-[var(--rose)]/50" data-id="element-19" data-mp="ogn45td4aj3a">
              <div className="flex items-center gap-3" data-id="element-20" data-mp="fha4fsesp8vr">
                <span className="font-serif-display text-4xl font-bold text-[var(--slate)]/50" data-id="element-21" data-mp="2est23auneuq4">
                  {bono.number}
                </span>
                <span className="text-2xl" aria-hidden="true" data-id="element-22" data-mp="29uj6x08xbu4i">
                  {bono.emoji}
                </span>
              </div>
              <h3 className="mt-3 font-semibold text-[var(--text)]" data-id="element-23" data-mp="qxr0aarv0kng">
                {bono.title}
              </h3>
              <p className="mt-2 flex-1 text-sm text-[var(--text-soft)]" data-id="element-24" data-mp="huzp8c2wbqwc">
                {bono.description}
              </p>
              <div className="mt-4 flex items-center gap-3" data-id="element-25" data-mp="muuds8z784e8">
                <span className="text-sm text-[var(--text-soft)] line-through" data-id="element-26" data-mp="1ajdr52x3v7d6">
                  {bono.price}
                </span>
                <span className="rounded-full bg-[var(--rose)] px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-[var(--bg-deep)]" data-id="element-27" data-mp="1ejxj7s2tnksg">
                  Gratis
                </span>
              </div>
            </article>)}
        </div>

        <p className="mt-10 text-center text-lg font-semibold text-[var(--text)]" data-id="element-28" data-mp="1ti9go0y0qxko">
          Valor total bonos:{' '}
          <span className="text-[var(--text-soft)] line-through" data-id="element-29" data-mp="1y9hquz76amyw">
            $60.000 ARS
          </span>{' '}
          <span className="text-[var(--rose)]" data-id="element-30" data-mp="285883vwvlrze">→ Gratis con Pilates Clinic</span>
        </p>
      </div>
    </section>;
}